import { useEffect, useState } from 'react';

import { prepareFilter } from 'libs/common';
import { Controller } from 'libs/control';
import { useSort } from 'libs/hooks';
import { ActionGrid } from './grid';
import ActionFilter from './filter';

export const Action = (props) => {
  const [items, setItems] = useState({});
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [sortParams, setSortParams] = useSort('actions', [{ field_name: 'timestamp', direction: 'desc' }]);

  useEffect(() => {
    setItems({});
    return () => setItems({});
  }, [props.clientId]);

  /**
   * prepare params
   * @param {*} data
   * @returns
   */
  const prepareParams = (data) => {
    const intFields = ['role_id'];
    const addParams = {};
    return prepareFilter(data, addParams, { intFields });
  };

  // grid actions
  const gridActions = {
    addEntries: (data) => setItems({ ...items, ...data }),
    clearEntries: () => setItems({}),
    updateEntry: (id, data) => {
      const newItems = { ...items };
      newItems[id] = { ...newItems[id], ...data };
      setItems(newItems);
    },
    setSortParams: (data) => setSortParams(data),
    setOffset: (val) => setOffset(val),
    setCount: (val) => setCount(val),
  };

  // grid params
  const gridParams = {
    entries: items,
    offset,
    count,
    sortParams,
  };

  return (
    <Controller {...props} {...gridParams} {...gridActions} type="actions" filterName="actionFilter" grid={ActionGrid} gridFilter={ActionFilter} getRequestParams={prepareParams} />
  );
};
